import { createFetchRequester } from '@algolia/requester-fetch';
import { algoliasearch, SearchClient } from 'algoliasearch';
import { ApiClient } from '../client/ApiClient';
import { AlgoliaStoreData } from './types/AlgoliaStoreData';

export type StoreClientConstructorArgs = {
  algoliaAppId: string;
  algoliaSearchApiKey: string;
  algoliaSearchIndex: string;
};
export class StoreClient extends ApiClient {
  private _algoliaClient: SearchClient;
  private _algoliaSearchIndex: string;

  constructor({ algoliaAppId, algoliaSearchApiKey, algoliaSearchIndex }: StoreClientConstructorArgs) {
    super();
    this._algoliaSearchIndex = algoliaSearchIndex;
    this._algoliaClient = algoliasearch(algoliaAppId, algoliaSearchApiKey, { requester: createFetchRequester() });
  }

  async getStore(locationId: string): Promise<AlgoliaStoreData> {
    const response = (await this._algoliaClient.getObject({
      indexName: this._algoliaSearchIndex,
      objectID: locationId,
    })) as unknown as AlgoliaStoreData;

    return response;
  }

  async getStores(locationIds: Array<string>): Promise<Array<AlgoliaStoreData>> {
    const test = await this._algoliaClient.getObjects({
      requests: locationIds.map(locationId => ({ indexName: this._algoliaSearchIndex, objectID: locationId })),
    });

    return test.results as Array<AlgoliaStoreData>;
  }
}
